import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { Button, Form, Segment } from "semantic-ui-react";

const UrlAttachmentForm = ({ onSubmit, onCancel }) => {
  const [url, setUrl] = useState("");
  const [name, setName] = useState("");
  return (
    <Segment>
      <Form
        onSubmit={() =>
          onSubmit({
            key: uuidv4(),
            url,
            name,
            contentType: "application/x-kmd-url",
          })
        }
      >
        <Form.Field>
          <label>Link URL</label>
          <input
            placeholder="http://www.youtube.com/..."
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />
        </Form.Field>
        <Form.Field>
          <label>Link Name (optional)</label>
          <input
            placeholder="My YouTube video"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Form.Field>
        <Button type="button" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" disabled={url.length === 0}>
          Add Link
        </Button>
      </Form>
    </Segment>
  );
};

export default UrlAttachmentForm;
